import React from 'react';
import styled from 'styled-components';
import { Skeleton, Stack } from '@mui/material';

/**
 * TableSkeleton 컴포넌트 Props
 * @typedef {Object} TableSkeletonProps
 * @property {number} row - 스켈레톤 행 개수
 * @property {string} [p='0px'] - 패딩
 * @property {string} [height='49px'] - 높이
 * @property {number} [spacing=0.4] - 간격
 * @property {Object} [skeletonProps] - MUI Skeleton의 추가 props
 */

const TableSkeleton = ({ row, p = '0px', height = '49px', spacing = 0.4, ...skeletonProps }) => {
  const createArrayFromNumber = (num) => Array.from({ length: num });
  return (
    <Stack spacing={spacing} p={p}>
      {createArrayFromNumber(row).map((_, index) => (
        <Skeleton key={index} height={height} {...skeletonProps} />
      ))}
    </Stack>
  );
};

export default TableSkeleton;
